import React from "react"
import { toast } from "react-toastify"
import { NotificationsListItem } from "queues/NotificationsButton"
import { showToastsConfig } from "visits/showToastsConfig"
import { PostViewDataHelper, UpdateInfo } from "lib-core"
import { showDesktopNotifications } from "visits/showDesktopNotifications"

export class PostViewDataHelperWithNotifications extends PostViewDataHelper {
    updateNotifications(updates: UpdateInfo[]) {
        this.notifications = updates
        if (showToastsConfig()) {
            updates.slice(0, 3).forEach(u => {
                toast(
                    <NotificationsListItem update={u} />
                )
            })
        }

        if (document.hidden) {
            this.showDesktopNotifications(updates)
        }
    }

    async showDesktopNotifications(updates: UpdateInfo[]) {
        if (!showDesktopNotifications() || !updates.length) {
            return
        }
        const profileId = this.profile?._id
        updates = updates.filter(u => u.author._id !== profileId)
        if (!updates.length) {
            return
        }

        if (!("Notification" in window)) {
            console.error("desktop notifications not supported")
            return
        }

        if (Notification.permission === "denied") {
            return
        }

        if (Notification.permission !== "granted") {
            const permission = await Notification.requestPermission()
            // If the user accepts, let's create a notification
            if (permission !== "granted") {
                return
            }
        }

        new Notification(`Post '${this.post.title})' new update`)
    }    
}
